import "./index.scss";

import type { ReactNode } from "react";
import classnames from "classnames";

type Props = {
  className?: string;
  children: ReactNode;
  noMargin?: boolean;
};

/** @deprecated - please use components in common/core/form */
export function DeprecatedFormRow({ className, children, noMargin }: Props) {
  return <div className={classnames("FormRow", className, { noMargin })}>{children}</div>;
}
